import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    territoryCompatible: `${APP_CONFIG.care_cluster}/terr-compatibility/`,
  },
}
